// ssoConfig.js
import { LogLevel } from "@azure/msal-browser";

/**
 * Detecta o ambiente atual da mesma forma que getEnvironmentApiUrl() no api.jsx:
 * - Em dev local (NODE_ENV=development), retorna DEV
 * - Se o host contiver "thriveapp-...-dev", DEV
 * - Se for "…-test", TEST
 * - Se for "…-prod", PROD
 * - Se for "…-staging", considera TEST (pré-prod)
 * - Se host começa com "test.", TEST
 * - Se host começa com "thrivebat", PROD
 */
function detectEnvironment() {
  if (process.env.NODE_ENV === "development") {
    return "DEV";
  }

  const host = window.location.host.toLowerCase();

  if (host.includes("thriveapp")) {
    const parts = host.split("-");
    if (parts.length > 4) {
      const envPart = parts[4];
      if (envPart.startsWith("dev")) {
        return "DEV";
      }
      if (envPart.startsWith("test")) {
        return "TEST";
      }
      if (envPart.startsWith("prod")) {
        return "PROD";
      }
      // se for algo como "...-pro-staging-..."
      if (parts[5] && parts[5].includes("staging")) {
        return "PROD";
      }
    }
  }

  if (host.startsWith("test.")) {
    return "TEST";
  }

  if (host.startsWith("thrivebat")) {
    return "PROD";
  }

  // fallback seguro
  return "PROD";
}

const ENV = detectEnvironment();

const envConfigs = {
  DEV: {
    auth: {
      clientId: "4aea20ec-4849-4483-904e-cbfb29be466e",
      authority: "https://login.microsoftonline.com/1f60c692-db56-4f6a-abca-dd4beac49301",
      redirectUri: document.location.href.split('/')[0] + '//' + document.location.href.split('/')[2] + '/signin'
    },
    scopes: ["api://eae5a3aa-01c3-486d-9db6-e944243a21eb/apiorca-qa"]
  },
  TEST: {
    auth: {
      clientId: "7731fb98-ba2e-40d9-a65f-7b6dd47ae314",
      authority: "https://login.microsoftonline.com/ff9c7474-421d-4957-8d47-c4b64dec87b5",
      redirectUri: "https://wa-crn-ne-thriveapp-test-01-fmhaasgyb9ccfagj.northeurope-01.azurewebsites.net/signin"
    },
    scopes: ["api://8ab00396-c19d-429c-9b00-d442e991c33e/user_impersonation"]
  },
  PROD: {
    auth: {
      clientId: "c0baa0f0-95d0-48ce-92c4-c0d00a404a13",
      authority: "https://login.microsoftonline.com/ff9c7474-421d-4957-8d47-c4b64dec87b5",
      redirectUri: document.location.href.split('/')[0] + '//' + document.location.href.split('/')[2] + document.location.host.startsWith("thrivebat") ? '/signIn' : '/signin'
    },
    scopes: ["api://09de15bd-a9ad-4bc0-a34e-a31de9329a8e/apithrive/user_impersonation"]
  }
};

const { auth, scopes } = envConfigs[ENV];

export const msalConfig = {
  auth,
  cache: {
    cacheLocation: "sessionStorage",
    storeAuthStateInCookie: false
  },
  system: {
    loggerOptions: {
      loggerCallback: (level, message, containsPii) => {
        if (containsPii) return;
        switch (level) {
          case LogLevel.Error:   console.error(message); break;
          case LogLevel.Info:    console.info(message);  break;
          case LogLevel.Verbose: console.debug(message); break;
          case LogLevel.Warning: console.warn(message);  break;
        }
      }
    }
  }
};

export const loginRequest = {
  scopes
};



// /*
//  * Copyright (c) Microsoft Corporation. All rights reserved.
//  * Licensed under the MIT License.
//  */

// import { LogLevel } from "@azure/msal-browser";

// /**
//  * Configuration object to be passed to MSAL instance on creation.
//  * For a full list of MSAL.js configuration parameters, visit:
//  * https://github.com/AzureAD/microsoft-authentication-library-for-js/blob/dev/lib/msal-browser/docs/configuration.md
//  */
// export const msalConfig = {
//     //DEV
//     // auth: {
//     //     clientId: "4aea20ec-4849-4483-904e-cbfb29be466e",
//     //     authority: "https://login.microsoftonline.com/1f60c692-db56-4f6a-abca-dd4beac49301",
//     //     redirectUri: document.location.href.split('/')[0] + '//' + document.location.href.split('/')[2] + '/signin'
//     // },
//     // BAT - Thrive QA
//     // auth: {
//     //     clientId: "7731fb98-ba2e-40d9-a65f-7b6dd47ae314",
//     //     authority: "https://login.microsoftonline.com/ff9c7474-421d-4957-8d47-c4b64dec87b5",
//     //     redirectUri: "https://wa-crn-ne-thriveapp-test-01-fmhaasgyb9ccfagj.northeurope-01.azurewebsites.net/signin"
//     // },
//     //BAT - Thrive PRD
//     auth: {
//         clientId: "c0baa0f0-95d0-48ce-92c4-c0d00a404a13",
//         authority: "https://login.microsoftonline.com/ff9c7474-421d-4957-8d47-c4b64dec87b5",
//         redirectUri: document.location.href.split('/')[0] + '//' + document.location.href.split('/')[2] + document.location.host.startsWith("thrivebat") ? '/signIn' : '/signin'
//     },
//     cache: {
//         cacheLocation: "sessionStorage", // This configures where your cache will be stored
//         storeAuthStateInCookie: false, // Set this to "true" if you are having issues on IE11 or Edge
//     },
//     system: {
//         loggerOptions: {
//             loggerCallback: (level, message, containsPii) => {
//                 if (containsPii) {
//                     return;
//                 }
//                 switch (level) {
//                     case LogLevel.Error:
//                         console.error(message);
//                         return;
//                     case LogLevel.Info:
//                         console.info(message);
//                         return;
//                     case LogLevel.Verbose:
//                         console.debug(message);
//                         return;
//                     case LogLevel.Warning:
//                         console.warn(message);
//                         return;
//                 }
//             }
//         }
//     }
// };

// /**
//  * Scopes you add here will be prompted for user consent during sign-in.
//  * By default, MSAL.js will add OIDC scopes (openid, profile, email) to any login request.
//  * For more information about OIDC scopes, visit:
//  * https://docs.microsoft.com/en-us/azure/active-directory/develop/v2-permissions-and-consent#openid-connect-scopes
//  */
// export const loginRequest = {
//     // DEV
//     // scopes: ["api://eae5a3aa-01c3-486d-9db6-e944243a21eb/apiorca-qa"]
//     //BAT - Thrive QA
//     // scopes: ["api://8ab00396-c19d-429c-9b00-d442e991c33e/user_impersonation"]
//     // BAT - Thrive PRD
//     scopes: ["api://09de15bd-a9ad-4bc0-a34e-a31de9329a8e/apithrive/user_impersonation"]
// };

// /**
//  * Add here the scopes to request when obtaining an access token for MS Graph API. For more information, see:
//  * https://github.com/AzureAD/microsoft-authentication-library-for-js/blob/dev/lib/msal-browser/docs/resources-and-scopes.md
//  */
// export const graphConfig = {
//     graphMeEndpoint: "https://graph.microsoft.com/v1.0/me"
// };
